// The logo comes only from brand-assets (BRAND.md). Accessible name "Substratal Apps".
export function BrandLockup({ variant = "inline" }: { variant?: "inline" | "horizontal" | "mark" }) {
  const base = variant === "mark" ? "/brand/mark" : `/brand/lockup-${variant}`;
  return (
    <picture className={`brand brand-${variant}`}>
      <source srcSet={`${base}-on-dark.svg`} media="(prefers-color-scheme: dark)" />
      <img src={`${base}.svg`} alt="Substratal Apps" />
    </picture>
  );
}
